module.exports = " \n\n<app-charts [chartData]=\"chartData\" [chartContainer]=\"'payment-status'\" [chartOpts]=\"chartOpts\"></app-charts>\n"